import { MenuItem } from '@mui/material';
import React from 'react';
import './menuItem.scss';

function CustomMenuItem({ 
  onClick = () => {}, 
  className = '', 
  icon, 
  children,
  disabled = false,
  ...props 
}) {
  return (
    <MenuItem
      onClick={onClick}
      className={`custom-menu-item ${className}`}
      disabled={disabled}
      {...props}
    >
      {icon && <span className='menu-item-icon'>{icon}</span>}
      {children}
    </MenuItem>
  );
}

export default CustomMenuItem; 